import i18n from '@/i18n';
import { defineStore } from 'pinia';

interface State {
  currentLocale: typeof i18n['global']['availableLocales'][number];
}

export const useI18nStore = defineStore('i18n', {
  state: (): State => ({
    currentLocale: 'en-AU',
  }),

  actions: {
    setLocale(newLocale: typeof i18n['global']['availableLocales'][number]) {
      this.currentLocale = newLocale;
      (i18n.global.locale as any).value = newLocale;
    },
  },

  persist: {
    storage: localStorage,
    paths: ['currentLocale'],
  },
});
